import { DOCUMENT } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { InitService } from './shared/services/init.service';
import { TenantService } from './shared/services/tenant.service';
import { TenantConfiguration } from './shared/types/tenant-configuration.interface';
import { WINDOW_PROVIDERS } from './shared/utils/window.token';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  providers: [
    InitService,
    WINDOW_PROVIDERS,
    TenantService
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',  
})
export class AppComponent implements OnInit {
  title = 'soma.volume.delivered.declaration';
  private initService = inject(InitService);
  private document = inject(DOCUMENT);

  ngOnInit(): void {
    if (this.initService.tenantConfig) {
      this.setTheme(this.initService.tenantConfig);
    } else {
      // Fallback: load config if APP_INITIALIZER failed
      this.initService.init().subscribe({
        next: (config) => {
          this.setTheme(config);
        },
        error: (error) => {
          console.error('❌ Failed to load tenant config:', error);
        }
      });
    }
  }

  setTheme(tenantConfig: TenantConfiguration) {
    document.documentElement.style.setProperty('--color-primary', tenantConfig.primaryColor);
    document.documentElement.style.setProperty('--color-secondary', tenantConfig.secondaryColor);
    document.documentElement.style.setProperty('--color-tertiary', tenantConfig.tertiaryColor);
    document.documentElement.style.setProperty(
      '--color-button-text',
      tenantConfig.buttonTextColor
    );
    document.documentElement.style.setProperty(
      '--icon-url',
      tenantConfig.iconUrl
    );

    // Atualizar título
    this.updatePageTitle(tenantConfig);

    // Atualizar favicon
    this.updateFavicon(tenantConfig.iconUrl);
  }

  private updatePageTitle(tenantConfig: TenantConfiguration) {
    const newTitle = `${tenantConfig.name} - Solicitação de Declaração de Volume`;
    document.title = newTitle;
  }

  private updateFavicon(iconUrl: string): void {
    // Remove todos os favicons existentes
    const existingFavicons = this.document.querySelectorAll("link[rel*='icon']");
    existingFavicons.forEach(icon => icon.remove());

    // Adiciona o novo favicon com cache-busting
    const link: HTMLLinkElement = this.document.createElement('link');
    link.rel = 'icon';
    link.href = `${iconUrl}?v=${Date.now()}`;
    this.document.head.appendChild(link);
  }
}
